import { withContext } from '@piggybank/core';
import { FieldContext } from '@piggybank/form';
import { TelephoneInputMax as PiggybankTelephoneInputMax } from '@piggybank/form/lib/es/components/TelephoneInput/TelephoneInputMax/TelephoneInputMax';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import T from 'prop-types';
import React from 'react';
import { getSchemaAtCursor } from '../../utils';

export class TelephoneInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.parseValue(props);
  }

  componentDidUpdate(prevProps) {
    // Ensures component state is up to date when Cypress fills in the field.
    // This will not be present in production builds.
    if (
      window.Cypress &&
      !isEmpty(this.props.value) &&
      this.props.value !== 'incomplete' &&
      this.props.value !== 'invalid' &&
      this.props.value !== prevProps.value
    ) {
      this.setState(this.parseValue(this.props));
    }
  }

  parseValue = ({ onChange, value }) => {
    const phoneNumber =
      parsePhoneNumberFromString(value ? `+${value}` : '') || {};

    const isPhoneNumberValid = phoneNumber.isValid && phoneNumber.isValid();

    if (!isPhoneNumberValid) {
      onChange({
        invalid: true,
        value: 'invalid',
      });
    }

    return {
      countryCode: get(phoneNumber, 'country', ''),
      raw: get(phoneNumber, 'nationalNumber', ''),
      value: isPhoneNumberValid ? get(phoneNumber, 'number', '') : '',
    };
  };

  handleChange = ({ event, value }) => {
    const { onChange } = this.props;

    this.setState(value);

    onChange({
      value: get(value, 'value', '').replace(/^\+/, ''),
      event,
    });
  };

  render() {
    const { context, validate, ...props } = omit(this.props, ['onChange']);
    const schemaNode = getSchemaAtCursor(context.schemaPath, validate.schema);

    return (
      <PiggybankTelephoneInputMax
        {...props}
        {...(schemaNode.minLength
          ? {
              minLength: schemaNode.minLength,
            }
          : {})}
        {...(schemaNode.maxLength
          ? {
              maxLength: schemaNode.maxLength,
            }
          : {})}
        onChange={this.handleChange}
        value={this.state}
      />
    );
  }
}

TelephoneInput.reviewFormatter = ({ formData }) => formData;

TelephoneInput.propTypes = {
  context: T.shape({
    schemaPath: T.arrayOf(T.string),
  }),
  onChange: T.func,
  value: T.string,
  validate: T.func,
};

export default withContext(FieldContext, props =>
  pick(props, [
    'name',
    'value',
    'onChange',
    'onBlur',
    'invalid',
    'required',
    'describers',
  ])
)(TelephoneInput);
